import { FC, memo } from "react";

export const LayoutPlain: FC = memo(({ children }) => <>{children}</>);
